// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"fff12090","882":"6022c6f9","990":"89c3d351"}[chunkId] + ".chunk.css";
};